import { supabase } from '../lib/supabaseClient';
import { getSportByName, getSportBySlug, sportToSlug } from './sports';

export const FALLBACK_CATEGORIES = [
  'Formula Series',
  'Football',
  'Cricket',
  'Rugby',
  'Baseball',
  'Basketball',
  'Volleyball',
];

/** @deprecated Prefer fetchStorefrontCategories(); kept for sync callers */
export const CATEGORIES = FALLBACK_CATEGORIES;

export function categoryToSlug(category) {
  const sport = getSportByName(category);
  if (sport) return sport.slug;
  return String(category || '')
    .toLowerCase()
    .replace(/\s+/g, '-');
}

/** Map legacy names like F1 onto the canonical storefront sport label. */
export function normalizeCategoryName(name) {
  const sport = getSportByName(name);
  return sport?.name || name;
}

export function normalizeStorefrontCategories(categories = []) {
  const seen = new Set();
  const normalized = [];

  categories.forEach((category, index) => {
    const rawName = typeof category === 'string' ? category : category.name;
    const name = normalizeCategoryName(rawName);
    const sport = getSportByName(name);
    const slug = sport?.slug || categoryToSlug(name);

    if (!name || seen.has(slug)) return;
    seen.add(slug);

    if (typeof category === 'string') {
      normalized.push({
        id: slug,
        name,
        slug,
        display_order: index + 1,
        visible: true,
      });
      return;
    }

    normalized.push({
      ...category,
      name,
      slug,
    });
  });

  return normalized;
}

export function slugToCategory(slug, categories = FALLBACK_CATEGORIES) {
  if (!slug) return null;

  const sport = getSportBySlug(slug);
  if (sport) return sport.name;

  const normalized = slug.toLowerCase().replace(/-/g, ' ');
  const list = categories.map(item => (typeof item === 'string' ? item : item.name));

  const match = list.find(
    category => category.toLowerCase().replace(/\s+/g, ' ') === normalized
  );
  return match ? normalizeCategoryName(match) : null;
}

export async function fetchStorefrontCategories() {
  if (!supabase) {
    return normalizeStorefrontCategories(
      FALLBACK_CATEGORIES.map((name, index) => ({
        id: name,
        name,
        slug: sportToSlug(name),
        display_order: index + 1,
        visible: true,
      }))
    );
  }

  const { data, error } = await supabase
    .from('categories')
    .select('id, name, slug, display_order, visible, image_url')
    .eq('visible', true)
    .order('display_order', { ascending: true });

  if (error || !data?.length) {
    return normalizeStorefrontCategories(
      FALLBACK_CATEGORIES.map((name, index) => ({
        id: name,
        name,
        slug: sportToSlug(name),
        display_order: index + 1,
        visible: true,
      }))
    );
  }

  return normalizeStorefrontCategories(data);
}
